import type { GameInfoType } from '@patrianna/shared-patrianna-types/store/SlotGameFlowModule'
import { intlnumberFormat } from '@patrianna/shared-utils/numbers'
import cx from 'classnames'
import type { ReactNode } from 'react'

import type { SupportedCurrencies } from 'types/currencies'

import classes from './styles.module.scss'

type Props = {
  gameBetsAndPrizes: GameInfoType
  activeCurrency: SupportedCurrencies
  isDarkMode?: boolean
  children?: ReactNode
  descriptionColor?: string
  title: string
  captionClassName: string
  descriptionClassName: string
  isGameDescription?: boolean
}

function MinMaxContainer({
  children,
  gameBetsAndPrizes,
  activeCurrency,
  isDarkMode,
  descriptionColor,
  title,
  captionClassName,
  descriptionClassName,
  isGameDescription,
}: Props) {
  const getFormattedValue = (bet: number) =>
    intlnumberFormat(bet, 'en-US', {
      style: 'decimal',
      minimumFractionDigits: bet % 1 ? 2 : 0,
    })

  return (
    <>
      <span className={cx('mt-typography-caption', classes[captionClassName])}>
        <span className={cx(!isGameDescription && classes.captionText, isDarkMode && classes.captionDarkMode)}>
          {title}
        </span>
        {children}
      </span>
      <span className={cx('mt-typography-caption', classes[descriptionClassName], descriptionColor)}>
        <b>
          {activeCurrency} {getFormattedValue(gameBetsAndPrizes.minBet)} / {activeCurrency}{' '}
          {getFormattedValue(gameBetsAndPrizes.maxBet)}
        </b>
      </span>
    </>
  )
}

export default MinMaxContainer
